import {Stack} from '@mui/material';
import {CTAButtonFixed} from 'presentation/components/CTAButtonFixed';
import {styled} from '@mui/material/styles';

const CustomCTAButtonFixedAction = styled(CTAButtonFixed.Action)`
	padding: 8px 22px;
`;

const StyledCard = styled(Stack)`
	padding: 16px;
	border-radius: 8px;
	gap: 16px;

	background-color: ${({theme}) => theme.colors.brand.primary.white};
`;

const ProviderSelectionContainer = styled(Stack)(({theme}) => ({
	width: '100%',
	[theme.breakpoints.up('lg')]: {
		width: '66.6667%',
	},
	margin: '0 auto',
}));

export {CustomCTAButtonFixedAction, StyledCard, ProviderSelectionContainer};
